import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router'
import { useTheme } from '../../lib/hooks'

import Button from '@/components/Button'
import Panel from '@/components/Panel'
import ProductItem from '@/components/ProductItem'
import View from '@/layout/View'

import useCheckout from '../Checkout/hooks/useCheckout'
import withScanner from '../Scanner/withScanner'
import { ProductEmpty, ProductHeader, ProductImage, ProductPrice, ProductTitle, ProductWrapper } from './Product.styles'

const Product = () => {
  const [product, setProduct] = useState({})
  const { id } = useParams()
  const { t } = useTranslation()
  const { addToCart } = useCheckout()
  const navigate = useNavigate()
  const themes = useTheme()
  const relatedProducts = useMemo(() => themes.products.filter(o => product?.relatedProducts?.includes(o.id)), [product])

  const handleAddToCart = () => {
    addToCart(product)
    navigate('/checkout')
  }

  useEffect(() => {
    setProduct(themes.products.find(o => o.id === id))
  }, [id])

  return (
    <View
      theme="LIGHT"
      middle={true}
      showBack
      footer={
        <Button variant="primary" onClick={handleAddToCart} prependIcon="plus">
          {t('addToCart')}
        </Button>
      }
    >
      {product && (
        <ProductWrapper>
          <ProductHeader>
            <ProductTitle>{product.title}</ProductTitle>
            {themes.currency === '£' ? <ProductPrice>
              {themes.currency}
              {product.price?.toFixed(2)}
              <sup>
                {themes.currency}
                {(product.price / 1.2).toFixed(2)} ex VAT
              </sup>
            </ProductPrice> : <ProductPrice>
              {product.price?.toFixed(2)}
              {themes.currency}
              <sup>
                {(product.price / 1.2).toFixed(2)} {themes.currency} ex VAT
              </sup>
            </ProductPrice>}
          </ProductHeader>
          <ProductImage>
            <img src={product.imageUrl} alt="" />
          </ProductImage>
          <Panel title={t('overview')}>{product.description}</Panel>
          <Panel title={t('technicalSpecification')}>
            {product.details?.map((o, i) => (
              <dl key={i}>
                <dt>{o.name}</dt>
                <dd>{o.value}</dd>
              </dl>
            ))}
          </Panel>
          <Panel title={t('relatedProducts')}>
            {relatedProducts.map(o => (
              <ProductItem key={o.id} {...o} />
            ))}
          </Panel>
        </ProductWrapper>
      )}
      {!product && <ProductEmpty>{t('cantFindProduct')}</ProductEmpty>}
    </View>
  )
}

export default withScanner(Product)
